/**
 * logUserActivity, writes a single row to Supabase `user_activity_log`
 * so the dashboard "Latest activity" feed picks up every meaningful
 * user action (milestone added, expense logged, checklist ticked,
 * stage changed, project type changed, etc.).
 *
 * Mirrors the iOS app pattern. Safe to call from anywhere, silently
 * no-ops if the user isn't signed in or the insert fails. Never throws.
 *
 * Usage:
 *   logUserActivity({
 *     type: 'milestone',
 *     title: 'Milestone added',
 *     description: 'Slab Down, 2 Feb 2026',
 *   });
 *
 * Allowed `type` values (mirrors iOS `activityToType`):
 *   - 'milestone'         (e.g. milestone added/completed)
 *   - 'expense'           (cost tracker)
 *   - 'generate'          (project health, AI features)
 *   - 'save' / 'favourite' (bookmarks)
 *   - 'upload'            (documents, photos)
 *   - 'email_rejected'    (inbound email errors)
 *   - 'system'            (default / other)
 */
import { getSupabase } from './supabaseClient';

export async function logUserActivity({ type = 'system', title, description }) {
  try {
    const supabase = getSupabase();
    const { data: { user } } = await supabase.auth.getUser();
    if (!user?.id) return;
    await supabase.from('user_activity_log').insert({
      user_id: user.id,
      activity_type: type,
      activity_title: title || 'Activity',
      activity_description: description || '',
      created_at: new Date().toISOString(),
    });
  } catch {
    /* silent */
  }
}
